import FooterSectionImages from "./FooterSectionImages";
import CurrentNews from "./CurrentNews";
import RecentlyUpdatedFiles from "./RecentlyUpdatedFiles";
import RecentlyUpdatedPages from "./RecentlyUpdatedPages";

const Footer = () => {
  return (
    <footer className={`
      gap-4
      pt-5
      grid 
      grid-cols-1
      w-full 
      [@media(min-width:700px)]:!grid-cols-3 
      px-2
      [@media(min-width:700px)]:!px-[48px]
    `}>
      <section>
        <CurrentNews />
      </section>
      <section>
        <RecentlyUpdatedFiles />
        <RecentlyUpdatedPages />
      </section>
      <section>
        <FooterSectionImages />
      </section>
    </footer>
  );
};
export default Footer;
